import Chip from "./chip.atom";

export default Chip;
